import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import MetodoOasi from "@/pages/MetodoOasi";
import Pacchetti from "@/pages/Pacchetti";
import SuperGaranzia from "@/pages/SuperGaranzia";
import Guida from "@/pages/Guida";
import PrenotaSopralluogo from "@/pages/PrenotaSopralluogo";
import Faq from "@/pages/Faq";
import Contatti from "@/pages/Contatti";
import GrazieSopralluogo from "@/pages/GrazieSopralluogo";
import GrazieGuida from "@/pages/GrazieGuida";
import Privacy from "@/pages/Privacy";
import Cookie from "@/pages/Cookie";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/metodo-oasi" element={<MetodoOasi />} />
          <Route path="/pacchetti" element={<Pacchetti />} />
          <Route path="/super-garanzia" element={<SuperGaranzia />} />
          <Route path="/guida-ristrutturazione-bagno" element={<Guida />} />
          <Route path="/prenota-sopralluogo" element={<PrenotaSopralluogo />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/grazie-sopralluogo" element={<GrazieSopralluogo />} />
          <Route path="/grazie-guida" element={<GrazieGuida />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie" element={<Cookie />} />

          <Route path="/configuratore-render" element={<Navigate to="/prenota-sopralluogo" replace />} />
          <Route path="/verifica-bagno" element={<Navigate to="/prenota-sopralluogo" replace />} />
          <Route path="/grazie-render" element={<Navigate to="/grazie-sopralluogo" replace />} />
          <Route path="/admin/*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
